import React from 'react';
import PropTypes from 'prop-types';
import GeneralDialogLayout from '@Containers/Dialogs/GeneralDialogLayout';
import ForgotPasswordDialogFooter from './Components/ForgotPasswordDialogFooter';
import ForgotPasswordDialogHeader from './Components/ForgotPasswordDialogHeader';
import ForgotPasswordDialogContent from './Components/ForgotPasswordDialogContent';

import './ForgotPasswordDialog.scss';

function ForgotPasswordDialog({
  email,
  setEmail,
  closeDialog,
  isLoading,
  result,
  onEmailSubmit,
  isEmailValid,
  trackAdobeAnalyticsError,
}) {
  const [requestSent, setRequestSent] = React.useState(false);

  const submit = () => {
    setRequestSent(true);
    if (!isEmailValid) {
      return;
    }
    onEmailSubmit();
  };

  return (
    <GeneralDialogLayout
      selfClose={closeDialog}
      className="forgot-password-dialog"
      size="md"
      layoutType="nothing"
      movable={false}
      header={<ForgotPasswordDialogHeader />}
      footer={(
        <ForgotPasswordDialogFooter
          result={result}
          submit={submit}
          close={closeDialog}
          isLoading={isLoading}
        />
)}
    >
      <ForgotPasswordDialogContent
        isEmailValid={isEmailValid}
        result={result}
        requestSent={requestSent}
        email={email}
        setEmail={setEmail}
        isLoading={isLoading}
        trackAdobeAnalyticsError={trackAdobeAnalyticsError}
      />
    </GeneralDialogLayout>
  );
}
ForgotPasswordDialog.propTypes = {
  closeDialog: PropTypes.func.isRequired,
  email: PropTypes.string,
  setEmail: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  result: PropTypes.string,
  isEmailValid: PropTypes.bool,
  trackAdobeAnalyticsError: PropTypes.func.isRequired,
  onEmailSubmit: PropTypes.func.isRequired,
};

export default ForgotPasswordDialog;
